module.exports = __webpack_public_path__ + "static/media/documentMob.1e055d46.jpg";